import {useState} from 'react'
import {MultiSelect, Option} from 'react-multi-select-component'
import '../../../../../../../style/multiSelectSucess.css'

interface IListSearchStatus {
  selectsStatus: Option[]
  setSelectsStatus: (value: Option[]) => void
  setSubscriptionStatusSearch: (value: string) => void
}
const ListSearchStatus = ({
  setSubscriptionStatusSearch,
  selectsStatus,
  setSelectsStatus,
}: IListSearchStatus) => {
  const initialSelectValue = [
    {value: '1', label: 'Pendente'},
    {value: '2', label: 'Pago'},
    {value: '3', label: 'Cancelado'},
    {value: '4', label: 'Falha'},
    {value: '5', label: 'Substituído'},
  ]
  const [paymentStatusOptions, setPayentStatusOptions] = useState<Option[]>(initialSelectValue)

  return (
    <>
      <div className='mb-5'>
        <label className='form-label fs-6 fw-bold'>Pesquisar Por Status:</label>
        <MultiSelect
          className='form-control rmscStyle'
          data-kt-user-table-filter='gender'
          options={paymentStatusOptions}
          value={selectsStatus}
          onChange={(option) => {
            const valores = option.map((item) => item.value)
            setSubscriptionStatusSearch(valores)
            setSelectsStatus(option)
          }}
          labelledBy={''}
          overrideStrings={{
            selectSomeItems: 'Selecione o(os) Status',
            search: 'Procurar',
            selectAll: 'Selecionar todos',
            allItemsAreSelected: 'Todos gêneros selecionados',
          }}
        />
      </div>
    </>
  )
}

export {ListSearchStatus}
